import { PaymentType } from "../../../../generated/graphql";

export type SubscriptionFormValues = {
  paymentDate: string;
  validity?: string;
  paymentType?: PaymentType | "";
  planId: string;
  pupilsCount?: string;
  teachersCount?: string;
  total: string;
  paymentTypeId?: string;
  payerId?: string;
  boardsCount?: string;
};

export const validateForm = (
  values: SubscriptionFormValues,
  isPersonal: boolean
) => {
  const errors: { [key: string]: string } = {};

  const fieldsToSkipInPersonal = ["pupilsCount", "teachersCount"];
  const optionalFields = ["boardsCount"];

  for (let key in values) {
    if (key === "total") continue;
    if (fieldsToSkipInPersonal.includes(key) && isPersonal) continue;
    if (optionalFields.includes(key)) continue;

    if (!values[key]) {
      errors[key] = "Це поле є обов’язковим";
    }
  }

  if (
    values.total?.length &&
    (isNaN(Number(values.total)) || Number(values.total) < 0)
  ) {
    errors.total = "Значення повинно бути числом і не менше 0";
  }

  if (values.boardsCount?.trim()) {
    const raw = values.boardsCount.trim().replace(",", ".");
    const parsed = Number(raw);
    const isNotPositiveInteger = !/^[1-9]\d*$/.test(raw);

    if (isNotPositiveInteger || isNaN(parsed)) {
      errors.boardsCount = "Значення повинно бути додатним цілим числом";
    }
  }

  if (!isPersonal) {
    if (values.validity?.length) {
      if (
        isNaN(Number(values.validity)) ||
        Number(values.validity) < 1 ||
        Number(values.validity) % 1 !== 0
      ) {
        errors.validity = "Значення повинно бути цілим числом >= 1";
      }
    }

    if (
      values.pupilsCount?.length &&
      (isNaN(Number(values.pupilsCount)) || Number(values.pupilsCount) <= 0)
    ) {
      errors.pupilsCount = "Значення повинно бути додатним числом";
    }

    if (
      values.teachersCount?.length &&
      (isNaN(Number(values.teachersCount)) || Number(values.teachersCount) <= 0)
    ) {
      errors.teachersCount = "Значення повинно бути додатним числом";
    }
  }

  return errors;
};
